'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HELPER_APPEARANCE = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _WixComponent2 = require('../BaseComponents/WixComponent');

var _WixComponent3 = _interopRequireDefault(_WixComponent2);

var _Text = require('../Text');

var _Text2 = _interopRequireDefault(_Text);

var _Button = require('../Button');

var _Button2 = _interopRequireDefault(_Button);

var _Close = require('../Icons/dist/components/Close');

var _Close2 = _interopRequireDefault(_Close);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HELPER_APPEARANCE = exports.HELPER_APPEARANCE = {
  warning: _styles2.default.warning,
  standard: _styles2.default.standard,
  danger: _styles2.default.danger,
  success: _styles2.default.success,
  premium: _styles2.default.premium
};

/**
 * Used in pages where you need to explain or mention things about the content or actions
 */

var SectionHelper = function (_WixComponent) {
  _inherits(SectionHelper, _WixComponent);

  function SectionHelper() {
    _classCallCheck(this, SectionHelper);

    return _possibleConstructorReturn(this, (SectionHelper.__proto__ || Object.getPrototypeOf(SectionHelper)).apply(this, arguments));
  }

  _createClass(SectionHelper, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames3.default)(_styles2.default.root, HELPER_APPEARANCE[this.props.appearance]) },
        this.props.onClose && _react2.default.createElement(
          'div',
          { className: (0, _classnames3.default)(_styles2.default.close, _defineProperty({}, _styles2.default.closeWithTitle, this.props.title)) },
          _react2.default.createElement(_Button2.default, {
            dataHook: 'sectionhelper-close-btn',
            size: 'large',
            theme: 'close-dark',
            onClick: this.props.onClose,
            children: _react2.default.createElement(_Close2.default, { size: '8px' })
          })
        ),
        this.props.title && _react2.default.createElement(
          'div',
          { className: _styles2.default.title },
          _react2.default.createElement(
            _Text2.default,
            { dataHook: 'sectionhelper-title', appearance: 'T4' },
            this.props.title
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _styles2.default.content },
          _react2.default.createElement(
            _Text2.default,
            { appearance: 'T3' },
            this.props.children
          )
        ),
        this.props.onAction && this.props.actionText && _react2.default.createElement(
          'div',
          { className: _styles2.default.action },
          _react2.default.createElement(_Button2.default, {
            height: 'small',
            theme: 'outlined',
            onClick: this.props.onAction,
            dataHook: 'sectionhelper-action-btn',
            children: this.props.actionText
          })
        )
      );
    }
  }]);

  return SectionHelper;
}(_WixComponent3.default);

SectionHelper.propTypes = {
  /** Sets the look and feel of the component */
  appearance: _propTypes2.default.oneOf(Object.keys(HELPER_APPEARANCE)),

  /** Adds text as the title */
  title: _propTypes2.default.node,

  /** When provided, will make a close button appear and invoke it upon click */
  onClose: _propTypes2.default.func,

  /** When provided, will make an action button appear and invoke it upon click */
  onAction: _propTypes2.default.func,

  /** Text label for the action button */
  actionText: _propTypes2.default.string,

  /** Children to render */
  children: _propTypes2.default.node
};

SectionHelper.defaultProps = {
  appearance: 'warning'
};

exports.default = SectionHelper;